import { useMutation, UseMutationResult, useQueryClient } from "@tanstack/react-query";
import axios from "axios";
import { enum_api_uri } from "../../../utils/enum";
import { useAuthStore } from "../../../../../console/store/useAuthStore";

interface WordRequest {
    status: boolean;
    event_category_idx: number;
    wreath_word: string;
    search_word: string;
}

export const usePutWord = (successCallback?: () => void, wordId?: string): UseMutationResult<null, Error, WordRequest, unknown> => {
    const queryClient = useQueryClient();
    const accessToken = useAuthStore(state => state.accessToken);

    return useMutation<null, Error, WordRequest>({
        mutationFn: async (wordData: WordRequest) => {
            const response = await axios.put(`${enum_api_uri.put_word}/${wordId}`, wordData, {
                headers: {
                    Authorization: `Bearer ${accessToken}`,
                },
            });
            return response.data.data;
        },
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ["getWordList"] });
            successCallback?.();
        },
    });
};
